export class GroupPayorServiceTableBO {
    id: string="00000000-0000-0000-0000-000000000000";
    agencyId: string | null;
    icd10: string;
    isIcd10FromClient: boolean | null = true;
    groupId: string="00000000-0000-0000-0000-000000000000";
    groupName: string;
    payorName: string;
    groupPayorId: string="00000000-0000-0000-0000-000000000000";
    masterServiceId: string;
    serviceDescription: string;
    billingUnitLid: string;
    authLimitLid: string;
    serviceName: string;
    billingUnit: string;
    netRate: number | null;
    unitrate: number | null;
    hcpcCode: string;
    callTypeID: number | null;
    unitMultiplier: number | null;
    billIndividually: boolean | null;
    revCode: string;
    providerLid: number | null;
    companyIdentifier: boolean | null;
    g2id: string;
    npi: string;
    companyName: string;
    name: string;
    address1: string;
    address2: string;
    city: string;
    state: string;
    zipCode: string;
    facilityID: string;
    serviceLoc: string;
    pharm: boolean | null;
    homeVisit: boolean | null;
    rateChangeDate: string | null;
    oldUCRate: number | null;
    oldNetRate: number | null;
    waiverFlag: boolean;
    combineClaim: boolean;
    taxonomyCode: string;
    atypical:string;
    umpiPayorUMPIMust:boolean;
    statusLid:any;
    claimAttachment: boolean;
    supervisingProvider: boolean;
    referringProvider: boolean;

}
export class GroupPayorServiceList {
    id: string="00000000-0000-0000-0000-000000000000";
    groupName: string;
    groupId: string="00000000-0000-0000-0000-000000000000";
    payorName: string;
    groupPayorId: string="00000000-0000-0000-0000-000000000000";
    serviceName: string;
    masterServiceId: string="00000000-0000-0000-0000-000000000000";
    billingUnitLid: string="00000000-0000-0000-0000-000000000000";
    netRate: number | null;
    serviceLoc: string;
    name: string;
    address1: string;
    facilityID: string;
    billingUnit: string;

}
export class grp {
    Group: string="00000000-0000-0000-0000-000000000000";
    Payor: string="00000000-0000-0000-0000-000000000000";
    Service: string="00000000-0000-0000-0000-000000000000";
    Billing: string="00000000-0000-0000-0000-000000000000";
    FacilityName: string = "";
    FacilityId: string = "";
}
export class filters {
    groupId: string = "0";
    groupPayorId: string = "0";
    service: string = "0"
    billingUnitLid: string = "0"
    name: string = ""
    FacilityId: string = ""
}
export class sortingObj {

    itemperpage: number = 20;
    currentPgNo: number = 1;
    shortcolumn: string = "groupName";
    shortType: string = 'asc';
}
export class functionpermission {
    grouppayorservicecreate: boolean = true;
    grouppayorservicedelete: boolean = true;
    grouppayorserviceupdate: boolean = true;

}
export class WhereCondition {
    field: string = "groupName";
    value: string = "";
    operator: string = "startswith";
    orderNo: number = 1;
    predicate: string = "and";
    type: string = "string";
    matchCase: boolean = false;
}

export class GetGroupPayorServiceBO {
    orderColumn: string = "groupName";
    orderType: string = "asc";
    pageitem: number = 10;
    currentpageno: number = 1;
    agencyID: number;
    field: string = "serviceDescription";
    value: string = "";
    matchCase: boolean = false;
    operator: string;
    serviceId:string;
    statusLid:string;

}
export class columnWidth {
    column: string = "";
    width: number = 0;
}

export class ColumnChangeBO {
    id: number = 0;
    userid: number = 0;
    agencyId: number = 0;
    column: string;
}


export class UpdateRatesInBulk {
    masterServiceId: string;
    netRate: number | null;
    unitrate: number | null;
    rateChangeDate: string | null;
}